"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRowHeight = void 0;
require("../components/StorageWidgetCell/types");
const ROW_HEIGHTS = {
    base: 48,
    allSecondRows: 88,
    someSecondRows: 60,
};
const getRowHeight = (rows) => {
    const hasSomeSecondTexts = rows.some((cellProps) => cellProps.secondTitle || cellProps.secondDescription);
    const hasAllSecondTexts = rows.some((cellProps) => cellProps.secondTitle && cellProps.secondDescription);
    if (hasAllSecondTexts) {
        return ROW_HEIGHTS.someSecondRows;
    }
    if (hasSomeSecondTexts) {
        return ROW_HEIGHTS.someSecondRows;
    }
    return ROW_HEIGHTS.base;
};
exports.getRowHeight = getRowHeight;
//# sourceMappingURL=getRowHeight.js.map